import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "w-full" }
const _hoisted_2 = { class: "grid grid-cols-1 gap-4 md:grid-cols-12" }
const _hoisted_3 = { class: "md:col-span-12" }
const _hoisted_4 = { class: "rounded-lg border border-slate-200 bg-white p-4" }
const _hoisted_5 = { class: "grid grid-cols-1 gap-4 md:grid-cols-12" }
const _hoisted_6 = { class: "flex min-w-0 flex-col md:col-span-5 lg:col-span-4" }
const _hoisted_7 = { class: "flex items-center gap-2" }
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "m-0 font-medium text-slate-800" }
const _hoisted_10 = { class: "flex min-w-0 flex-col md:col-span-3 lg:col-span-2" }
const _hoisted_11 = { class: "md:col-span-12" }
const _hoisted_12 = { class: "overflow-hidden rounded-lg border border-slate-200 bg-white" }
const _hoisted_13 = { class: "p-4" }
const _hoisted_14 = { class: "flex flex-wrap items-center justify-between gap-3" }
const _hoisted_15 = { class: "flex items-center gap-3" }
const _hoisted_16 = { class: "relative flex w-full" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Button = _resolveComponent("Button")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_Panel = _resolveComponent("Panel")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Panel, { header: "Quản lý nhận góp ý" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("section", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _cache[5] || (_cache[5] = _createElementVNode("label", null, "Chọn thành viên", -1)),
                  _createVNode(_component_Dropdown, {
                    modelValue: $setup.managerFb.zaloId,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.managerFb.zaloId) = $event)),
                    options: $setup.listCustomer,
                    optionLabel: "name",
                    optionValue: "id",
                    placeholder: "Chọn tài khoản",
                    filter: true
                  }, {
                    option: _withCtx((slotProps) => [
                      _createElementVNode("div", _hoisted_7, [
                        (slotProps.option.imageUrl)
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 0,
                              src: slotProps.option.imageUrl,
                              class: "mr-1 h-5 w-5 rounded object-cover"
                            }, null, 8, _hoisted_8))
                          : _createCommentVNode("", true),
                        _createElementVNode("label", _hoisted_9, _toDisplayString(slotProps.option.name), 1)
                      ])
                    ]),
                    _: 1
                  }, 8, ["modelValue", "options"])
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _cache[6] || (_cache[6] = _createElementVNode("label", null, "Thêm", -1)),
                  _createVNode(_component_Button, {
                    label: "Thêm",
                    icon: "pi pi-plus-circle",
                    iconPos: "left",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.addMember())),
                    loading: $setup.addingManager,
                    disabled: !$setup.managerFb.zaloId
                  }, null, 8, ["loading", "disabled"])
                ])
              ])
            ])
          ]),
          _createElementVNode("section", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _cache[8] || (_cache[8] = _createElementVNode("div", { class: "border-b border-slate-200 bg-slate-50 px-4 py-3 text-[15px] font-bold text-slate-900" }, " Danh sách thành viên nhận góp ý ", -1)),
              _createElementVNode("div", _hoisted_13, [
                _createVNode(_component_DataTable, {
                  loading: $setup.isLoading,
                  value: $setup.listManagerFb,
                  paginator: true,
                  stripedRows: "",
                  rows: 10,
                  rowsPerPageOptions: [10, 25, 50],
                  rowHover: true,
                  filters: $setup.filters,
                  "onUpdate:filters": _cache[4] || (_cache[4] = ($event: any) => (($setup.filters) = $event)),
                  paginatorTemplate: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown",
                  globalFilterFields: ['zaloName'],
                  currentPageReportTemplate: "Có tổng số {totalRecords} thành viên",
                  columnResizeMode: "fit | expand"
                }, {
                  header: _withCtx(() => [
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("div", _hoisted_15, [
                        _createVNode(_component_Button, {
                          type: "button",
                          icon: "pi pi-filter-slash",
                          label: "Xoá lọc",
                          outlined: "",
                          onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.clearFilter()))
                        }),
                        _createElementVNode("span", _hoisted_16, [
                          _cache[7] || (_cache[7] = _createElementVNode("i", { class: "pi pi-search pointer-events-none absolute left-3 top-1/2 z-10 -translate-y-1/2 text-sm text-slate-400" }, null, -1)),
                          _createVNode(_component_InputText, {
                            class: "!w-[400px] !pl-8 !pr-3",
                            modelValue: $setup.filters['global'].value,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.filters['global'].value) = $event)),
                            placeholder: "Tìm theo tên hoặc số điện thoại"
                          }, null, 8, ["modelValue"])
                        ])
                      ])
                    ])
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_Column, {
                      field: "zaloName",
                      header: "Họ và tên",
                      sortable: ""
                    }),
                    _createVNode(_component_Column, { header: "Hành động" }, {
                      body: _withCtx((slotProps) => [
                        _createVNode(_component_Button, {
                          severity: "danger",
                          label: "Xoá",
                          icon: "pi pi-trash",
                          onClick: ($event: any) => ($setup.deleteManager(slotProps.data.id)),
                          loading: $setup.deletingManagerId === slotProps.data.id
                        }, null, 8, ["onClick", "loading"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["loading", "value", "filters"])
              ])
            ])
          ])
        ])
      ]),
      _: 1
    })
  ]))
}